<template>
  <PortfolioFormLayout :loading="loading">
    <template #header>
      <h5 class="my-2">
        {{ isUpdateForm ? 'Update' : 'Create' }}
        {{ isPenalty ? 'Penalty' : 'Service Level Objective' }}
      </h5>
    </template>
    <template #body>
      <SloForm v-if="isPenalty === false" :id="id" :is-update-form="isUpdateForm" />
      <PenaltyForm v-else-if="isPenalty === true" :id="id" :is-update-form="isUpdateForm" />
    </template>
  </PortfolioFormLayout>
</template>
<script lang="ts" setup>
defineProps<{
  isUpdateForm: boolean;
  loading: boolean;
  id?: number;
}>();

const route = useRoute();
const isPenalty = computed(() => (route.query?.p ? true : false));
</script>
